<script setup lang="ts">
import { inject, Ref, computed, ref } from 'vue';
import { cloneDeep } from 'lodash';
import Button from 'primevue/button';
import EditPassenger from '@/components/book/EditPassenger.vue';

const dialogRef = inject('dialogRef') as Ref;
let passengerDataProp = dialogRef.value.data.passengerData;
const isCruise = dialogRef.value.data?.isCruise;
const isSave = dialogRef.value.options.emits.isSave;

const passengerData = ref({});
passengerData.value = cloneDeep(passengerDataProp);

const savePassenger = (data) => {
  passengerDataProp = data;
  isSave(passengerDataProp);
};
const totalEconomyPassengers = computed(() => {
  return (parseInt(passengerData.value.adtNo, 10) ?? 0) + (parseInt(passengerData.value.chdNo, 10) ?? 0);
});

const totalBusinessPassengers = computed(() => {
  return (parseInt(passengerData.value.businessAdtNo, 10) ?? 0) + (parseInt(passengerData.value.businessChdNo, 10) ?? 0);
});

const totalEconomyCruisePassengers = computed(() => {
  return (parseInt(passengerData.value.flights[0].adt, 10) ?? 0) + (parseInt(passengerData.value.flights[0].chd, 10) ?? 0);
});

const totalBusinessCruisePassengers = computed(() => {
  return (parseInt(passengerData.value.flights[0].businessAdt, 10) ?? 0) + (parseInt(passengerData.value.flights[0].businessChd, 10) ?? 0);
});
</script>
<template>
  <div class="modal-mask passenger_modal">
    <div class="modal-container grid card">
      <div class="lg:col passenger_detail lg:mr-3 md:mr-3">
        <EditPassenger :passengerData="passengerData" :totalPassenger="isCruise ? totalEconomyCruisePassengers : totalEconomyPassengers" :isCruise="isCruise" :detailType="'economy'"></EditPassenger>
      </div>
      <div class="lg:col passenger_detail lg:ml-3 md:ml-3 business_class">
        <EditPassenger :passengerData="passengerData" :totalPassenger="isCruise ? totalBusinessCruisePassengers : totalBusinessPassengers" :isCruise="isCruise" :detailType="'business'"></EditPassenger>
      </div>
    </div>
    <div class="flex justify-content-center">
      <Button class="uppercase" id="save_updates" :label="$t('book_form.save_updates')" @click="savePassenger(passengerData)" />
    </div>
  </div>
</template>
<style lang="scss">
.passenger_detail {
  input {
    width: 50px;
    text-align: center;
  }
}
.passenger_modal {
  padding-top: 20px;
}
@media screen and (max-width: 991px) {
  .passenger_modal {
    .card {
      padding: 2rem;
    }
  }
}
</style>
<style lang="scss" scoped>
.total_style {
  width: 50px;
  text-align: center;
}
@media screen and (max-width: 514px) {
  .business_class {
    margin-top: 20px;
  }
}
@media screen and (max-width: 544px) {
  .passenger_modal {
    .modal-container {
      justify-content: center;
    }
  }
}
</style>
